import { useMemo } from "react";
import { useSearchParams } from "react-router";
import { applyFilter, enrich, FILTER_KEYS, labelOf, type FilterKey, type TicketFilter } from "@server/reporting/metrics";
import { useTicketRows } from "../../api/client";
import { filterFromParams, paramsFromFilter } from "./filters";

// The tickets, and the filters in the page address that narrow them. Shared by the reports and the All tickets page.
export function useTicketReport() {
  const [params, setParams] = useSearchParams();
  const query = useTicketRows();
  const all = useMemo(() => enrich(query.data?.rows ?? []), [query.data]);
  const filter = useMemo(() => filterFromParams(params), [params]);
  const rows = useMemo(() => applyFilter(all, filter), [all, filter]);
  // Every value found in all tickets, so a choice does not vanish from a list when another filter is applied.
  const options = useMemo(
    () =>
      Object.fromEntries(FILTER_KEYS.map((key) => [key, [...new Set(all.map((row) => labelOf(row, key)))].sort((a, b) => a.localeCompare(b))])) as Record<FilterKey, string[]>,
    [all],
  );
  const setFilter = (next: TicketFilter): void => setParams(paramsFromFilter(next), { replace: true });
  return { query, all, filter, rows, options, setFilter };
}
